/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import api from '../../../../services/api'
import React, { useState, useEffect, useCallback } from 'react'
import CryptoJS from 'crypto-js'
import moment from 'moment'
import 'moment/locale/pt'

import {
  Box,
  Typography,
  Grid,
  TextField,
  Button as MUIButton,
  CardContent,
  Card as MUICard,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Modal,
} from '@mui/material'
import FixedContainer from '../../../../components/Container'
import { AddFilesModal } from './components/AddFilesModal'
import { AnticipateCprModal } from './components/AnticipateCprModal'
import CupomViewer from '../CupomViewer'
import HistorieViewer from '../HistorieViewer'
import CprAccrualByDay from '../CprAccrualByDay'
import CprNotes from '../CprNotes'
import { TiInputChecked, TiMediaStopOutline } from 'react-icons/ti'
import { useLocation, useNavigate } from 'react-router-dom'
import { enqueueSnackbar } from 'notistack'
import { GetFetch, PostFetch } from '../../../../services/apiBase'
import { ActiveCprModal } from './components/ActiveCprModal'
import axios from 'axios'

const Detalhes = (props) => {
  const location = useLocation()
  const navigate = useNavigate()

  const [cprs, setCprs] = useState(null)
  const [flowType, setFlowType] = useState(null)
  const [flowTypeCpr, setFlowTypeCpr] = useState(null)
  const [renderPDF, setRenderPDF] = useState(false)
  const [base64Customer, setBase64Customer] = useState()
  const [base64Bank, setBase64Bank] = useState()
  const [modal, setModal] = useState(false)
  const [showCupomViewer, setShowCupomViewer] = useState(false)
  const [showCprHistoricViewer, setShowCprHistoricViewer] = useState(false)
  const [showCprAccrualByDay, setShowCprAccrualByDay] = useState(false)

  const [showCprNotes, setShowCprNotes] = useState(false)
  const [notes, setNotes] = useState([])
  const [openModalNew, setOpenModalNew] = useState(false)
  const [openActiveCprModal, setOpenActiveCprModal] = useState(false)
  const [openAnticipateModal, setOpenAnticipateModal] = useState(false)
  const [cprNumber, setCprNumber] = useState('')
  const [personneId, setPersonneId] = useState('')
  const [cprSignedDocument, setCprSignedDocument] = useState()
  const [isSended, setIsSended] = useState(false)
  const [load, setLoad] = useState(true)
  const [isLoadingSendToSign, setIsLoadingSendToSign] = useState(false)

  const user = JSON.parse(localStorage.getItem('user'))

  const toggleModal = () => setModal(!modal)

  const toggleOpenModalNew = async () => {
    console.log(isSended)
    if (openModalNew) {
    }
    if (isSended) {
      setIsSended(false)
      handleBackHistory()
    }
    setOpenModalNew(!openModalNew)
  }

  const handleGetCprDetails = async (cpr_number, personne_id) => {
    const response = await GetFetch(
      `/financial/showCpr?cpr_number=${cpr_number}&personne_id=${personne_id}`
    )
    console.log('handleGetCprDetails > ', response.data)
    setCprs(response.data)
  }

  useEffect(() => {
    if (!location.state) {
      return navigate('/cprf/geradas')
    } else {
      handleGetPDF(location.state.cpr)
      handleGetCprDetails(
        location.state.cpr.cpr_number,
        location.state.cpr.personne_id
      )
      handleGetFlowType(location.state.cpr)
      getNotes(location.state.cpr.id)
      setCprNumber(location.state.cpr.cpr_number)
      setPersonneId(location.state.cpr.personne_id)
    }
    setIsSended(false)
  }, [location])

  const handleBackHistory = () => {
    return navigate('/cprf/geradas')
  }

  const handleActiveFlowType = async () => {
    const dataToUpdate = {
      status: 'Realizado',
      username: user.username,
    }
    const ciphertext = localStorage.getItem('@JWT_HASH')
    var bytes = CryptoJS.AES.decrypt(
      ciphertext,
      process.env.REACT_APP_TOKEN_ENCRYPT_HASH
    )
    var JWT = bytes.toString(CryptoJS.enc.Utf8)
    api.defaults.headers.authorization = `Bearer ${JWT}`
    const response = await api.put(
      `/financial/updateCprEventFlow?cpr_number=${cprs.cpr_number}&personne_id=${cprs.personne_id}&flow_type=create_cpr&flow_name=${flowTypeCpr.flow_name}`,
      dataToUpdate
    )
    handleGetFlowType(cprs)
    toggleModal()
    enqueueSnackbar('FlowType marcado como realizado!', { variant: 'success' })
  }

  const handleVerifyFlowType = (e) => {
    if (e.status === 'Pendente') {
      setFlowTypeCpr(e)
      toggleModal()
    } else {
      enqueueSnackbar('Este flow já está ativo', { variant: 'error' })
    }
  }

  const handleGetFlowType = async (cpr) => {
    const response = await GetFetch(
      `/financial/showCprEventFlow?cpr_number=${cpr.cpr_number}&personne_id=${cpr.personne_id}`
    )

    /*
      let config = {
        headers: {
          'Authorization': `Bearer ${JWT}`
        }
      }
        
      const response = await axios.get(`http://localhost:4600/financial/showCprEventFlow?cpr_number=${cpr.cpr_number}&personne_id=${cpr.personne_id}`,
        config
      );
    */
    setFlowType(response.data[0].cpr_event_flow)
  }

  const handleGetPDF = async (cpr) => {
    setLoad(true)
    const ciphertext = localStorage.getItem('@JWT_HASH')
    var bytes = CryptoJS.AES.decrypt(
      ciphertext,
      process.env.REACT_APP_TOKEN_ENCRYPT_HASH
    )
    var JWT = bytes.toString(CryptoJS.enc.Utf8)
    api.defaults.headers.authorization = `Bearer ${JWT}`
    const responsecustomer = await api.post(`/financial/cprBase64`, {
      cpr_number: cpr.cpr_number,
      personne_id: cpr.personne_id,
      type_email: 'customer',
    })
    setBase64Customer(responsecustomer.data.content_B64)
    const responsebank = await api.post(`/financial/cprBase64`, {
      cpr_number: cpr.cpr_number,
      personne_id: cpr.personne_id,
      type_email: 'bank',
    })
    setBase64Bank(responsebank.data.content_B64)

    const responseSignedDocument = await api.post(`/financial/cprBase64`, {
      cpr_number: cpr.cpr_number,
      personne_id: cpr.personne_id,
      type_email: 'signed',
    })

    if (typeof responseSignedDocument.data === 'string') {
      setCprSignedDocument(responseSignedDocument.data)
    }

    setLoad(false)
  }

  const handleSeePDF = () => {
    setRenderPDF(!renderPDF)
  }

  const handleActiveCPR = async () => {
    const cpr = cprs
    try {
      const user = JSON.parse(localStorage.getItem('user'))

      const dataToUpdate = {
        status: 'ativa',
        username: user.username,
      }

      const ciphertext = localStorage.getItem('@JWT_HASH')
      var bytes = CryptoJS.AES.decrypt(
        ciphertext,
        process.env.REACT_APP_TOKEN_ENCRYPT_HASH
      )
      var JWT = bytes.toString(CryptoJS.enc.Utf8)
      api.defaults.headers.authorization = `Bearer ${JWT}`
      const response = await api.put(
        `/financial/updateStatusCpr?cpr_number=${cprs.cpr_number}&personne_id=${cprs.personne_id}&status=ativa&username=${user.username}`,
        dataToUpdate
      )

      console.log(response)
      let message = `CPR nº ${cprs.cpr_number} ativada com sucesso`
      enqueueSnackbar(message, { variant: 'success' })
      return navigate('/cprf/ativas')
    } catch (error) {
      enqueueSnackbar('Não foi possível ativar a CPR', { variant: 'error' })
      enqueueSnackbar(error.response.data.error, { variant: 'error' })

      const user = JSON.parse(localStorage.getItem('user'))

      const dataToUpdate = {
        status: 'gerada',
        username: user.username,
      }
      await api.put(
        `/financial/updateStatusCpr?cpr_number=${cprs.cpr_number}&personne_id=${cprs.personne_id}`,
        dataToUpdate
      )
      console.log({ cpr })

      setCprs(cpr)
    }
  }

  const handleDesactiveCPR = async () => {
    const cpr = cprs

    try {
      setCprs(null)
      const user = JSON.parse(localStorage.getItem('user'))

      const dataToUpdate = {
        status: 'cancelada',
        username: user.username,
      }

      const ciphertext = localStorage.getItem('@JWT_HASH')
      var bytes = CryptoJS.AES.decrypt(
        ciphertext,
        process.env.REACT_APP_TOKEN_ENCRYPT_HASH
      )
      var JWT = bytes.toString(CryptoJS.enc.Utf8)
      api.defaults.headers.authorization = `Bearer ${JWT}`
      const response = await api.put(
        `/financial/updateStatusCpr?cpr_number=${cprs.cpr_number}&personne_id=${cprs.personne_id}&status=cancelada&username=${user.username}`,
        dataToUpdate
      )
      let message = `CPR nº ${cprs.cpr_number} cancelada com sucesso`
      enqueueSnackbar(message, { variant: 'success' })
      return navigate('/cprf/geradas')
    } catch (error) {
      enqueueSnackbar('Não foi possível cancelar a CPR', { variant: 'error' })
      enqueueSnackbar(error.response.data.error, { variant: 'error' })
      setCprs(cpr)
    }
  }

  const handleStage = () => {
    if (cprs.stages) {
      if (cprs.stages == 'no_renew') {
        return 'Não Renovar'
      }
    }
    return 'Renovar'
  }

  const handleCupomViewer = () => {
    setShowCupomViewer(!showCupomViewer)
    setShowCprHistoricViewer(false)
    setShowCprAccrualByDay(false)
  }

  const handleCprHistoricViewer = () => {
    setShowCprHistoricViewer(!showCprHistoricViewer)
    setShowCupomViewer(false)
    setShowCprAccrualByDay(false)
  }

  const handlesCprAccrualByDay = async () => {
    setShowCupomViewer(false)
    setShowCprHistoricViewer(false)
    setShowCprAccrualByDay(!showCprAccrualByDay)
  }

  const handleSendCprToSign = async () => {
    try {
      setIsLoadingSendToSign(true);
      await PostFetch(
        `/financial/sendCprToSign`,
        {
          cpr_id: cprs.id,
          personne_id: cprs.personne_id,
        }
      );
      window.location.reload();
      enqueueSnackbar(`CPR ${cprs.cpr_number} enviada para assinatura com sucesso.`, { variant: 'success' })
    } catch (error) {
      console.error(error);
      enqueueSnackbar(`Não foi possível enviar a CPR ${cprs.cpr_number} para assinatura`, { variant: 'error' })
    } finally {
      setIsLoadingSendToSign(false);
    }
  }

  const getNotes = useCallback(async (cpr_id) => {
    try {
      const response = await GetFetch(`/financial/cpr/notes?cpr_id=${cpr_id}`)

      /** 
       let config = {
         headers: {
           'Authorization': `Bearer ${JWT}`
         }
       }
       
       const response = await axios.get(`http://localhost:4600/financial/cpr/notes?cpr_id=${cpr_id}`,
         config
       );
      */

      setNotes(response.data)
      console.log(response.data)
    } catch (error) {
      console.log(error)
      enqueueSnackbar('Erro ao carregar as observações', { variant: 'error' })
    }
  }, [])

  function institucionalEditButton(status, type) {
    if (
      ['gerada', 'ativa', 'resgate'].includes(status) &&
      type === 'institucional'
    ) {
      return (
        <>
          <MUIButton
            variant='contained'
            color='warning'
            sx={{ marginRight: 2 }}
            onClick={() => navigate('/cprf/cprEdit', { state: { cpr: cprs } })}
          >
            Editar
          </MUIButton>
        </>
      )
    }
  }

  function getMenuButtons(status) {
    if (status === 'gerada') {
      return (
        <>
          <MUIButton
            variant='contained'
            color='success'
            sx={{ marginRight: 2 }}
            onClick={() => setOpenActiveCprModal(true)}
          >
            Ativar CPR
          </MUIButton>

          <MUIButton
            variant='contained'
            color='error'
            sx={{ marginRight: 2 }}
            onClick={() => handleDesactiveCPR()}
          >
            Cancelar CPR
          </MUIButton>
        </>
      )
    }
    //
    if (status === 'ativa' || status === 'resgate') {
      return (
        <>
          <MUIButton
            variant='contained'
            color='error'
            sx={{ marginRight: 2 }}
            onClick={() => setOpenAnticipateModal(true)}
          >
            Antecipar CPR
          </MUIButton>
        </>
      )
    }
  }

  useEffect(() => {
    if (cprs) {
      getNotes(cprs.id)
    }
  }, [showCprNotes])

  return (
    <>
      {cprs ? (
        <FixedContainer>
          <Box
            sx={{
              width: '100%',
              height: '100%',
              backgroundColor: '#F9FBFD',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              boxShadow: 3,
              borderRadius: '10px',
              padding: 2,
            }}
          >
            <Typography
              variant='h6'
              sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 2 }}
            >
              CPRF's/Detalhes
            </Typography>

            <Box
              sx={{
                display: 'flex',
                width: '100%',
                justifyContent: 'flex-end',
                marginBottom: 2,
              }}
            >
              {cprs.shared_personne.type &&
                institucionalEditButton(cprs.status, cprs.shared_personne.type)}

              <MUIButton
                variant='contained'
                color='info'
                sx={{ marginRight: 2 }}
                onClick={() => handleBackHistory()}
              >
                Voltar
              </MUIButton>

              {getMenuButtons(cprs.status)}

              <MUIButton
                variant='contained'
                color='info'
                sx={{ marginRight: 2 }}
                onClick={() => handleSeePDF()}
              >
                Visualizar PDF
              </MUIButton>

            {cprs.send_to_sign && (
              <MUIButton
                variant='contained'
                color='info'
                sx={{ marginRight: 2 }}
                onClick={() => handleSendCprToSign()}
                disabled={isLoadingSendToSign}
              >
                Enviar para assinatura
              </MUIButton>
            )}
            </Box>

            {cprs.opportunity && cprs.opportunity.id && (
              <Typography
                variant='h6'
                sx={{
                  fontWeight: 700,
                  fontSize: '16px',
                  paddingTop: 1,
                  paddingBottom: 1,
                  color: '#BA2B00',
                }}
              >
                Essa CPRF foi criada a partir da oportunidade -{' '}
                {cprs.opportunity?.title
                  ? cprs.opportunity.title
                  : 'Não informado'}
              </Typography>
            )}

            {renderPDF && (
              <div
                style={{
                  width: '100%',
                  height: cprSignedDocument ? 3030 : 2030,
                  marginTop: 30,
                }}
              >
                <iframe
                  style={{ width: '100%', height: 1000 }}
                  src={`data:application/pdf;base64,${base64Bank}`}
                />

                <iframe
                  style={{ width: '100%', height: 1000 }}
                  src={`data:application/pdf;base64,${base64Customer}`}
                />
              </div>
            )}

            <Box>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Typography
                    variant='h5'
                    sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 2 }}
                  >
                    Pessoal
                  </Typography>

                  <Box>
                    <TextField
                      disabled
                      id='outlined-disabled'
                      label='Nome'
                      defaultValue={
                        cprs.shared_personne
                          ? cprs.shared_personne.name
                          : 'Não informado'
                      }
                      fullWidth
                    />
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginTop: 2,
                    }}
                  >
                    <TextField
                      disabled
                      id='outlined-disabled'
                      label='Data de Nascimento'
                      defaultValue={
                        cprs.shared_personne
                          ? cprs.shared_personne.birth_date
                            ? moment
                                .utc(cprs.shared_personne.birth_date)
                                .format('DD/MM/YYYY')
                            : 'Não informado'
                          : 'Não informado'
                      }
                      sx={{ width: '49%' }}
                    />
                    <TextField
                      disabled
                      id='outlined-disabled'
                      label='CPF'
                      defaultValue={
                        cprs.shared_personne
                          ? cprs.shared_personne.document_number
                            ? cprs.shared_personne.document_number
                            : 'Não informado'
                          : 'Não informado'
                      }
                      sx={{ width: '49%' }}
                    />
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginTop: 2,
                    }}
                  >
                    <TextField
                      disabled
                      id='outlined-disabled'
                      label='Estado civil'
                      defaultValue={
                        cprs.shared_personne
                          ? cprs.shared_personne.marital
                            ? cprs.shared_personne.marital
                            : 'Não informado'
                          : 'Não informado'
                      }
                      sx={{ width: '49%' }}
                    />
                    <TextField
                      disabled
                      id='outlined-disabled'
                      label='Sexo'
                      defaultValue={
                        cprs.shared_personne
                          ? cprs.shared_personne.gender
                            ? cprs.shared_personne.gender === 'M'
                              ? 'Masculino'
                              : cprs.shared_personne.gender === 'M'
                              ? 'Feminino'
                              : 'Outros'
                            : 'Não informado'
                          : 'Não informado'
                      }
                      sx={{ width: '49%' }}
                    />
                  </Box>
                  <Box sx={{ marginTop: 2 }}>
                    <TextField
                      disabled
                      id='outlined-disabled'
                      label='Email'
                      defaultValue={
                        cprs.shared_personne
                          ? cprs.shared_personne.email_principal
                            ? cprs.shared_personne.email_principal
                            : 'Não informado'
                          : 'Não informado'
                      }
                      fullWidth
                    />
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Typography
                    variant='h5'
                    sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 2 }}
                  >
                    Investimento
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}
                  >
                    <TextField
                      disabled
                      id='outlined-disabled'
                      label='Id da CPRF'
                      defaultValue={cprs.id}
                      sx={{ width: '49%' }}
                    />
                    <TextField
                      disabled
                      id='outlined-disabled'
                      label='Número da CPRF'
                      defaultValue={cprs.cpr_number}
                      sx={{ width: '49%' }}
                    />
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginTop: 2,
                    }}
                  >
                    <TextField
                      disabled
                      id='outlined-disabled'
                      label='Valor investido'
                      defaultValue={
                        cprs.amount_cpr
                          ? Intl.NumberFormat('pt-BR', {
                              style: 'currency',
                              currency: 'BRL',
                            }).format(cprs.amount_cpr)
                          : null
                      }
                      sx={{ width: '49%' }}
                    />
                    <TextField
                      disabled
                      id='outlined-disabled'
                      label='Taxa'
                      defaultValue={
                        cprs.rate_cpr
                          ? cprs.rate_cpr
                            ? `${cprs.rate_cpr} %`
                            : 'Não informado'
                          : cprs.rate_cpr
                      }
                      sx={{ width: '49%' }}
                    />
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginTop: 2,
                    }}
                  >
                    <TextField
                      disabled
                      id='outlined-disabled'
                      label='Valor final'
                      defaultValue={
                        cprs.amount_cpr_final
                          ? Intl.NumberFormat('pt-BR', {
                              style: 'currency',
                              currency: 'BRL',
                            }).format(cprs.amount_cpr_final)
                          : null
                      }
                      sx={{ width: '49%' }}
                    />
                    <TextField
                      disabled
                      id='outlined-disabled'
                      label='Data da geração'
                      defaultValue={
                        cprs.date_start
                          ? moment.utc(cprs.date_start).format('DD/MM/YYYY')
                          : null
                      }
                      sx={{ width: '49%' }}
                    />
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginTop: 2,
                    }}
                  >
                    <TextField
                      disabled
                      id='outlined-disabled'
                      label='Data da ativação'
                      defaultValue={
                        cprs.date_signed
                          ? moment.utc(cprs.date_signed).format('DD/MM/YYYY')
                          : null
                      }
                      sx={{ width: '49%' }}
                    />
                    <TextField
                      disabled
                      id='outlined-disabled'
                      label='Data final'
                      defaultValue={
                        cprs.date_end
                          ? moment.utc(cprs.date_end).format('DD/MM/YYYY')
                          : null
                      }
                      sx={{ width: '49%' }}
                    />
                    <TextField
                      disabled
                      id='outlined-disabled'
                      label='Renovar'
                      defaultValue={handleStage()}
                      sx={{ width: '49%' }}
                    />
                  </Box>

                  {['resgate', 'resgatada', 'ativa'].includes(cprs.status) &&
                    cprs.marketMark && (
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          marginTop: 2,
                        }}
                      >
                        <TextField
                          disabled
                          id='outlined-disabled'
                          label='Cupom vigente'
                          defaultValue={
                            cprs.marketMark?.currentYield
                              ? cprs.marketMark.currentYield
                              : 'Não informado'
                          }
                          sx={{ width: '38%' }}
                        />
                        <TextField
                          disabled
                          id='outlined-disabled'
                          label='Dias úteis'
                          defaultValue={
                            cprs.marketMark?.currentBusinessDay
                              ? cprs.marketMark.currentBusinessDay
                              : 'Não informado'
                          }
                          sx={{ width: '20%' }}
                        />
                        <TextField
                          disabled
                          id='outlined-disabled'
                          label='Valor acumulado'
                          defaultValue={
                            cprs.marketMark?.currentAcumulatedValue
                              ? Intl.NumberFormat('pt-BR', {
                                  style: 'currency',
                                  currency: 'BRL',
                                }).format(
                                  cprs.marketMark.currentAcumulatedValue +
                                    cprs.amount_cpr
                                )
                              : 'Não informado'
                          }
                          sx={{ width: '38%' }}
                        />
                      </Box>
                    )}
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginTop: 2,
                    }}
                  >
                    <TextField
                      disabled
                      id='outlined-disabled'
                      label='Status pendente'
                      defaultValue={
                        cprs.flowType[0]
                          ? cprs.flowType[0].event_flows.flow_description
                          : 'Não informado'
                      }
                      sx={{ width: '38%' }}
                    />
                    <TextField
                      disabled
                      id='outlined-disabled'
                      label='Arrobas'
                      defaultValue={
                        cprs.cprs_farmhouse[0]
                          ? cprs.cprs_farmhouse[0].product_weigth
                          : 'Não informado'
                      }
                      sx={{ width: '20%' }}
                    />
                    <TextField
                      disabled
                      id='outlined-disabled'
                      label='Status'
                      defaultValue={cprs.status ? cprs.status : 'Não informado'}
                      sx={{ width: '38%' }}
                    />
                  </Box>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Typography
                    variant='h5'
                    sx={{ fontWeight: 700, fontSize: '18px', marginTop: 3 }}
                  >
                    Endereço
                  </Typography>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginTop: 2,
                    }}
                  >
                    <TextField
                      disabled
                      id='outlined-disabled'
                      label='Rua'
                      defaultValue={
                        cprs.shared_personne
                          ? cprs.shared_personne.address_name
                            ? cprs.shared_personne.address_name
                            : 'Não informado'
                          : 'Não informado'
                      }
                      sx={{ width: '49%' }}
                    />
                    <TextField
                      disabled
                      id='outlined-disabled'
                      label='Numero'
                      defaultValue={
                        cprs.shared_personne
                          ? cprs.shared_personne.address_number
                            ? cprs.shared_personne.address_number
                            : 'Não informado'
                          : 'Não informado'
                      }
                      sx={{ width: '49%' }}
                    />
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginTop: 2,
                    }}
                  >
                    <TextField
                      disabled
                      id='outlined-disabled'
                      label='Bairro'
                      defaultValue={
                        cprs.shared_personne
                          ? cprs.shared_personne.address_county
                            ? cprs.shared_personne.address_county
                            : 'Não informado'
                          : 'Não informado'
                      }
                      sx={{ width: '49%' }}
                    />
                    <TextField
                      disabled
                      id='outlined-disabled'
                      label='CEP'
                      defaultValue={
                        cprs.shared_personne
                          ? cprs.shared_personne.address_postcode
                            ? cprs.shared_personne.address_postcode
                            : 'Não informado'
                          : 'Não informado'
                      }
                      sx={{ width: '49%' }}
                    />
                  </Box>

                  <Typography
                    variant='h5'
                    sx={{ fontWeight: 700, fontSize: '18px', marginTop: 3 }}
                  >
                    Alterações
                  </Typography>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginTop: 2,
                    }}
                  >
                    <TextField
                      disabled
                      id='outlined-disabled'
                      label='Atualizada em'
                      defaultValue={moment
                        .utc(cprs.updated_at)
                        .format('DD/MM/YYYY')}
                      sx={{ width: '49%' }}
                    />
                    <TextField
                      disabled
                      id='outlined-disabled'
                      label='Usuário'
                      defaultValue={cprs.username}
                      sx={{ width: '49%' }}
                    />
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Typography
                    variant='h5'
                    sx={{
                      fontWeight: 700,
                      fontSize: '18px',
                      paddingBottom: 2,
                      marginTop: 3,
                    }}
                  >
                    Fazenda
                  </Typography>

                  {cprs.cprs_farmhouse.map((farmhouse, index) => (
                    <Box key={index}>
                      <Box>
                        <TextField
                          disabled
                          id='outlined-disabled'
                          label='Nome'
                          defaultValue={farmhouse.farmhouse.name}
                          fullWidth
                        />
                      </Box>
                      <Box>
                        <TextField
                          disabled
                          id='outlined-disabled'
                          label='Proprietário'
                          defaultValue={farmhouse.farmhouse.owner}
                          fullWidth
                          sx={{ marginTop: 2 }}
                        />
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          marginTop: 2,
                        }}
                      >
                        <TextField
                          disabled
                          id='outlined-disabled'
                          label='Numero do registro'
                          defaultValue={farmhouse.farmhouse.register_number}
                          sx={{ width: '49%' }}
                        />
                        <TextField
                          disabled
                          id='outlined-disabled'
                          label='Cidade'
                          defaultValue={farmhouse.farmhouse.city.name_city}
                          sx={{ width: '49%' }}
                        />
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          marginTop: 2,
                        }}
                      >
                        <TextField
                          disabled
                          id='outlined-disabled'
                          label='Região'
                          defaultValue={farmhouse.farmhouse.city.name_region}
                          sx={{ width: '38%' }}
                        />
                        <TextField
                          disabled
                          id='outlined-disabled'
                          label='Estado'
                          defaultValue={farmhouse.farmhouse.city.name_uf}
                          sx={{ width: '20%' }}
                        />
                        <TextField
                          disabled
                          id='outlined-disabled'
                          label='País'
                          defaultValue={farmhouse.farmhouse.city.name_country}
                          sx={{ width: '38%' }}
                        />
                      </Box>
                    </Box>
                  ))}
                </Grid>
              </Grid>
            </Box>

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                margin: '24px 0',
              }}
            >
              <MUIButton
                variant='contained'
                color='info'
                sx={{ marginRight: 2 }}
                onClick={() => handleCprHistoricViewer()}
              >
                Visualizar histórico
              </MUIButton>

              <MUIButton
                variant='contained'
                color='info'
                sx={{ marginRight: 2 }}
                onClick={() => handleCupomViewer()}
              >
                Visualizar cupons
              </MUIButton>

              <MUIButton
                variant='contained'
                color='info'
                onClick={() => handlesCprAccrualByDay()}
              >
                Visualizar rendimento diário
              </MUIButton>
            </Box>

            {showCupomViewer && (
              <CupomViewer
                goBack={() => navigate('/cprf/ativas')}
                cupons={cprs.cprs_yield}
              />
            )}

            {showCprHistoricViewer && (
              <HistorieViewer cpr_history={cprs.cpr_histories} />
            )}

            {showCprAccrualByDay && (
              <CprAccrualByDay cprId={cprs.id} type={cprs.type} />
            )}

            <Box>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  {load ? (
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                      }}
                    >
                      <CircularProgress size={'2rem'} />
                    </Box>
                  ) : cprSignedDocument ? (
                    <Box>
                      <Typography
                        variant='h5'
                        sx={{
                          fontWeight: 700,
                          fontSize: '18px',
                          paddingBottom: 2,
                          marginTop: 3,
                        }}
                      >
                        Documento da CPRF assinado enviado
                      </Typography>
                      <MUIButton
                        variant='contained'
                        color='success'
                        sx={{ marginRight: 2 }}
                        onClick={() => {
                          window.location.href = cprSignedDocument
                        }}
                      >
                        Fazer download do documento assinado
                      </MUIButton>
                    </Box>
                  ) : (
                    <Box>
                      <Typography
                        variant='h5'
                        sx={{
                          fontWeight: 700,
                          fontSize: '18px',
                          paddingBottom: 2,
                          marginTop: 3,
                        }}
                      >
                        Inserir Documento de CPRF assinado
                      </Typography>
                      <MUIButton
                        variant='contained'
                        color='info'
                        sx={{ marginRight: 2 }}
                        onClick={() => toggleOpenModalNew()}
                      >
                        Inserir anexo
                      </MUIButton>
                    </Box>
                  )}
                  <Typography
                    variant='h5'
                    sx={{
                      fontWeight: 700,
                      fontSize: '18px',
                      paddingBottom: 2,
                      marginTop: 3,
                    }}
                  >
                    Observações
                  </Typography>
                  <Box>
                    {notes.length <= 0 && (
                      <Typography sx={{ margin: 2 }}>
                        Nunhuma observação cadastrada
                      </Typography>
                    )}

                    {notes.map((note, index) => (
                      <Box key={index} sx={{ marginBottom: 2 }}>
                        <MUICard>
                          <CardContent>
                            <Typography
                              variant='h5'
                              sx={{
                                fontWeight: 400,
                                fontSize: '14px',
                                paddingBottom: 2,
                                marginTop: 3,
                              }}
                            >
                              {note.comment}
                            </Typography>

                            <Box
                              sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                borderTop: '1px solid #C1CCD2',
                              }}
                            >
                              <Box
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontWeight: '700',
                                    fontSize: '12px',
                                  }}
                                >
                                  Usuário:{' '}
                                </Typography>
                                <Typography
                                  sx={{
                                    fontSize: '12px',
                                    marginLeft: 0.6,
                                  }}
                                >{`${note.username}`}</Typography>
                              </Box>
                              <Box
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: '12px',
                                    marginRight: 0.6,
                                  }}
                                >{`${moment
                                  .utc(new Date(note.created_at))
                                  .format('DD/MM/YYYY')}`}</Typography>
                                <Typography
                                  sx={{
                                    fontSize: '12px',
                                  }}
                                >
                                  {' '}
                                  às{' '}
                                  {moment
                                    .utc(new Date(note.created_at))
                                    .subtract(3, 'h')
                                    .format(`hh:mm`)}
                                </Typography>
                              </Box>
                            </Box>
                          </CardContent>
                        </MUICard>
                      </Box>
                    ))}

                    <MUIButton
                      variant='contained'
                      color='info'
                      sx={{ marginRight: 2 }}
                      onClick={() => setShowCprNotes(!showCprNotes)}
                    >
                      Nova
                    </MUIButton>
                  </Box>

                  {showCprNotes && (
                    <CprNotes
                      cpr_id={cprs.id}
                      open={showCprNotes}
                      onClose={() => setShowCprNotes(!showCprNotes)}
                    />
                  )}
                </Grid>
                <Grid item xs={6}>
                  <Typography
                    variant='h5'
                    sx={{
                      fontWeight: 700,
                      fontSize: '18px',
                      paddingBottom: 2,
                      marginTop: 3,
                    }}
                  >
                    Flow Type
                  </Typography>
                  {flowType &&
                    flowType.map((flow, index) => (
                      <Box
                        key={index}
                        sx={{
                          marginLeft: 2,
                          marginBottom: 2,
                          paddingBottom: 2,
                          borderTopLeftRadius: 10,
                          borderBottomRightRadius: 10,
                          backgroundColor: '#f0f1f5',
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: 'bold',
                              margin: 2,
                            }}
                          >
                            {flow.flow_description}
                          </Typography>
                          <Box
                            sx={{ display: 'flex', alignItems: 'center' }}
                            onClick={() => handleVerifyFlowType(flow)}
                          >
                            {flow.status === 'Pendente' ? (
                              <TiMediaStopOutline color='red' size={40} />
                            ) : (
                              <TiInputChecked color='green' size={35} />
                            )}
                          </Box>
                        </Box>
                        <Typography sx={{ margin: 2 }}>
                          {flow.instruction}
                        </Typography>
                      </Box>
                    ))}
                </Grid>
              </Grid>
            </Box>
          </Box>
        </FixedContainer>
      ) : (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            height: '100%',
            justifyContent: 'center',
            paddingTop: 2,
          }}
        >
          <CircularProgress />
        </Box>
      )}

      <Dialog open={modal} toggle={toggleModal}>
        <DialogTitle toggle={toggleModal}>Ativar FlowType</DialogTitle>
        <DialogContent style={{ backgroundColor: '#fff' }}>
          <p>Deseja ativar este FlowType?</p>
        </DialogContent>
        <DialogActions>
          <MUIButton
            variant='contained'
            color='error'
            sx={{ marginRight: 1 }}
            onClick={() => toggleModal()}
          >
            Não
          </MUIButton>
          <MUIButton
            variant='contained'
            color='success'
            onClick={() => handleActiveFlowType()}
          >
            Sim
          </MUIButton>
        </DialogActions>
      </Dialog>

      <AddFilesModal
        cprNumber={cprNumber}
        open={openModalNew}
        setIsSended={setIsSended}
        onClose={async () => {
          toggleOpenModalNew()
        }}
      />

      <Modal
        open={openActiveCprModal}
        onClose={() => setOpenActiveCprModal(false)}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <ActiveCprModal
          cpr={cprs}
          active={handleActiveCPR}
          onClose={async () => {
            setOpenActiveCprModal(false)
          }}
        />
      </Modal>

      <AnticipateCprModal
        cprNumber={cprNumber}
        coupons={cprs}
        personne_id={personneId}
        redirect={() => navigate('/cprf/ativas')}
        username={user.username}
        open={openAnticipateModal}
        onClose={async () => {
          setOpenAnticipateModal(false)
        }}
      />
    </>
  )
}

export default Detalhes
